<template>
    <div id="change-log">
        <h3>更新ログ</h3>

        <ul>
　　　　　　<li>2026/08/31 トップページのサイト名、更新内容、サイトの設立理由を記載</li>
            <li>2026/08/29 一般公開</li>
        </ul>

        <p class="source-site-link">
            本サイトは以下のサイトを参考に、荒らし対策機能のデモンストレーションを目的として作成したサイトです。<br />
            コピー元サイト：
            <a href="https://gikopoipoi.net/" target="_blank" rel="noopener noreferrer">
                ギコっぽいぽい
            </a>
        </p>
    </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
#change-log {
    line-height: 1.6;
}

#change-log h3 {
    margin-bottom: 6px;
}

#change-log ul {
    margin-top: 0;
    padding-left: 1.5em;
}

.source-site-link {
    margin-top: 8px;
}
</style>
